
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SettingsLayout } from '../../components/SettingsLayout';
import { CheckCircle, Add } from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';

export const IntegrationsScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const apps = [
    { name: t('integrations.shopify'), status: 'Connected', desc: t('integrations.shopifyDesc'), icon: 'https://cdn-icons-png.flaticon.com/512/174/174869.png', key: 'Shopify' },
    { name: t('integrations.amazon'), status: 'Connect', desc: t('integrations.amazonDesc'), icon: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg', key: 'Amazon' },
    { name: t('integrations.ozon'), status: 'Connect', desc: t('integrations.ozonDesc'), icon: 'https://upload.wikimedia.org/wikipedia/commons/e/e0/Ozon.ru_logo.svg', key: 'Ozon' },
    { name: t('integrations.slack'), status: 'Connect', desc: t('integrations.slackDesc'), icon: 'https://cdn-icons-png.flaticon.com/512/2111/2111615.png', key: 'Slack' }
  ];

  return (
    <SettingsLayout>
      <div className="max-w-4xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="mb-10">
            <h1 className="text-3xl font-bold text-slate-900 tracking-tight">{t('integrations.title')}</h1>
            <p className="text-slate-500 mt-2 text-base">{t('integrations.subtitle')}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {apps.map((app, i) => (
                <div key={i} className="bg-white border border-slate-200 rounded-xl p-6 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-slate-50 rounded-lg flex items-center justify-center p-2">
                            <img src={app.icon} alt={app.name} className="w-full h-full object-contain" />
                        </div>
                        <div>
                            <h3 className="font-bold text-slate-900">{app.name}</h3>
                            <p className="text-xs text-slate-500">{app.desc}</p>
                        </div>
                    </div>
                    {app.status === 'Connected' ? (
                        <button className="px-4 py-2 bg-emerald-50 text-emerald-600 text-xs font-bold rounded-lg border border-emerald-100 flex items-center gap-1">
                            <CheckCircle style={{ fontSize: 14 }} /> {t('integrations.connected')}
                        </button>
                    ) : (
                        <button
                            onClick={() => {
                                if (app.key === 'Ozon') {
                                    navigate('/stores/bind');
                                } else {
                                    alert(`Connecting to ${app.name}...`);
                                }
                            }}
                            className="px-4 py-2 bg-white text-slate-600 text-xs font-bold rounded-lg border border-slate-200 hover:border-primary hover:text-primary transition-colors flex items-center gap-1 active:scale-95"
                        >
                            <Add style={{ fontSize: 14 }} /> {t('integrations.connect')}
                        </button>
                    )}
                </div>
            ))}
        </div>
      </div>
    </SettingsLayout>
  );
};
